export default __webpack_public_path__ + "static/media/icon_managuser.bbbc5dd7.svg";